"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.env = void 0;
function getString(name) {
    const value = process.env[name] || process.env[`REACT_APP_${name}`];
    return value || null;
}
function getInteger(name) {
    const stringValue = getString(name);
    let integerValue = null;
    if (stringValue) {
        integerValue = parseInt(stringValue, 10);
        if (Number.isNaN(integerValue)) {
            integerValue = null;
        }
    }
    return integerValue;
}
function getBoolean(name) {
    const stringValue = getString(name);
    if (stringValue === null) {
        return null;
    }
    const lowerCaseStringValue = stringValue.toLowerCase();
    if (['true', 'false'].includes(lowerCaseStringValue)) {
        return stringValue.toLowerCase() === 'true';
    }
    return null;
}
exports.env = {
    getString,
    getInteger,
    getBoolean,
};
//# sourceMappingURL=env.js.map